<template>
  <div class="invoice">
    <van-nav-bar
      title="开发票"
      left-text=""
      left-arrow
      fixed
      class="main-nav"
      @click-left="onClickLeft"
    >
      <template #right>
        <div class="history" @click="goHistory">开票历史</div>
      </template>
    </van-nav-bar>
    <van-checkbox-group
      ref="checkboxGroup"
      v-model="checkResult"
      @change="changeGroup"
    >
      <div
        class="invoice_content"
        v-loading="loading"
        element-loading-text="数据加载中..."
      >
        <div class="invoice_content_listBox">
          <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            :finished-text="finishedText"
            error-text="数据加载失败"
            @load="onReachBottom"
          >
            <div class="noData" v-if="list.length == 0">
              <img src="../../assets/images/setting/noData.png" />
              <p>您还没有可开发票的订单</p>
            </div>
            <template v-else>
              <div v-for="item in list" class="invoice_content_list">
                <div class="invoice_content_list_top">
                  <van-checkbox
                    :name="item.id"
                    v-model="item.flag"
                    icon-size="22px"
                    checked-color="#00AADF"
                    @change="(val) => changeOne(val, item)"
                  >
                  </van-checkbox>
                  <p>
                    {{
                      item.invoiceState == 0
                        ? "未开票"
                        : item.invoiceState == 1
                        ? "开票中"
                        : "已开票"
                    }}
                  </p>
                </div>
                <div class="invoice_content_list_cen">
                  <img
                    :src="item.coverMaterialUrl"
                    class="invoice_content_list_cen_img"
                  />
                  <div class="invoice_content_list_cen_right">
                    <div class="invoice_content_list_cen_right_title">
                      {{ item.productName }}
                    </div>
                    <div class="invoice_content_list_cen_right_price">
                      <span>¥</span
                      >{{
                        item.originalPrice &&
                        item.originalPrice.toString().indexOf(".") > -1
                          ? item.originalPrice.toString().split(".")[0]
                          : item.originalPrice
                      }}<span
                        v-if="
                          item.originalPrice &&
                          item.originalPrice.toString().indexOf('.') > -1 &&
                          item.originalPrice.toString().split('.')[1]
                        "
                        >.{{
                          item.originalPrice.toString().split(".")[1]
                        }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="invoice_content_list_num">
                  <p>
                    订单编号：<span>{{ item.id }}</span>
                  </p>
                </div>
                <div class="invoice_content_list_num">
                  <p>
                    下单时间：<span>{{ item.createTime }}</span>
                  </p>
                </div>
              </div>
            </template>
          </van-list>
          <!-- </van-pull-refresh> -->
        </div>
        <div class="invoice_content_fix" v-if="list.length != 0">
          <div class="invoice_content_fix_top">
            {{ orderTol }}个订单，共{{ moneyTol }}元
          </div>
          <div class="invoice_content_fix_bot">
            <div class="invoice_content_fix_bot_left">
              <van-checkbox
                name="allChecked"
                v-model="selectAll"
                icon-size="22px"
                ref="checkAll"
                checked-color="#00AADF"
                @click.native="clickAllBtn"
              >
              </van-checkbox>
              <span>全部勾选</span>
            </div>
            <div
              class="invoice_content_fix_bot_rig"
              @click="next"
              :style="{
                background:
                  orderTol > 0
                    ? 'linear-gradient(180deg, #17E1EB 0%, #24BFFB 100%)'
                    : '#ccc',
              }"
            >
              下一步
            </div>
          </div>
        </div>
      </div>
    </van-checkbox-group>
  </div>
</template>
<script>
import { _orderList } from "../../api/setting";
export default {
  name: "invoice",
  data() {
    return {
      list: [], //数据列表
      orderTol: 0, //总订单
      moneyTol: 0, //总金额
      selectAll: false, //是否选中全部
      checkResult: [], //选中状态列表
      refreshing: false, //上拉标识
      loading: false, //loading标识
      pageNum: 1, //当前页数
      finished: true, //下拉结束标识
      finishedText: "", //下拉话术
    };
  },
  created() {
    this.getOrderList();
  },
  mounted() {
    // this.onRefresh();
  },
  watch: {
    //监听列表数据 计算总价格
    list: {
      handler(newVal) {
        let priceArr = [];
        priceArr = newVal
          .filter((v) => v.flag)
          .map((item) => item.originalPrice);
        this.moneyTol =
          priceArr.length > 0 ? eval(priceArr.join("+")).toFixed(2) : 0;
        this.orderTol = priceArr.length > 0 ? priceArr.length : 0;
      },
      deep: true,
    },
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    //点击列表复选框
    changeOne(val, item) {
      this.$refs.checkAll.toggle(this.checkStatus());
    },
    checkStatus() {
      let allFlag = this.list.every((item) => {
        return item.flag;
      });

      return allFlag;
    },
    //点击全部
    clickAllBtn() {
      this.$refs.checkboxGroup.toggleAll(!this.checkStatus());
      this.selectAll = !this.checkStatus();
    },
    //点击任意复选框
    changeGroup(data) {
      this.list.map((obj) => {
        data.includes(obj.id) ? (obj.flag = true) : (obj.flag = false);
      });
      if (this.list.length === data.length - 1) {
        this.$refs.checkAll.toggle(true);
        this.selectAll = true;
      } else {
        this.$refs.checkAll.toggle(false);
        this.selectAll = false;
      }
    },
    // 首次加载和下拉刷新
    onRefresh() {
      this.pageNum = 1;
      this.loadData();
    },
    // 数据处理
    loadData(type) {
      this.$refs.checkboxGroup.toggleAll(false);
      this.$refs.checkAll.toggle(false);

      if (type === "downRefresh") {
        // this.getOrderList();
      } else {
        this.refreshing = false; // 关闭顶部加载中···
      }
    },
    // 上拉加载，滚动条与底部距离小于 offset 时触发
    onReachBottom() {
      ++this.pageNum;
      this.loadData("downRefresh");
    },
    // 为每条数据加上check
    initData(data) {
      data.map((item) => {
        item.flag = false;
      });
      return data;
    },
    //点击下一步
    next() {
      let ordersId = this.checkResult;
      let ordersIds = [];
      let index = ordersId.indexOf("allChecked");
      if (index > -1) ordersId.splice(index, 1);
      for (var i = 0; i < ordersId.length; i++) {
        ordersIds.push({ id: ordersId[i] });
      }
      localStorage.setItem("ordersId", JSON.stringify(ordersIds));
      if (this.orderTol > 0) {
        this.$router.push({
          path: "/applyInvoice",
          query: { moneyTol: this.moneyTol },
        });
      }
    },
    //开票历史
    goHistory() {
      this.$router.push({ path: "/invoiceHistory" });
    },
    // 获取发票列表
    getOrderList(type) {
      this.loading = true;
      this.finished = false;
      _orderList({
        currentPage: this.pageNum,
        pageSize: 10,
        queryData: {
          invoiceState: "0",
          orderState: "1",
        },
      })
        .then((res) => {
          if (res && res.code == 200) {
            let result = res.data;
            result.record && this.initData(result.record);
            if (type == "downRefresh") {
              this.list = [...this.list, ...result.record];
            } else {
              this.list = result.record || [];
            }
            if (res.data.pages == this.pageNum || this.list.length == 0) {
              this.finished = true;
              this.finishText = "已加载完全部数据";
            }
            this.loading = false;
          } else {
            Toast(res.message);
            this.loading = false;
            this.finished = true;
            this.finishedText = "";
          }
        })
        .catch((err) => {
          this.finished = true;
          this.finishedText = "";
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.invoice {
  height: 100%;
  background: #f5f7fa;
  .history {
    width: 67px;
    height: 28px;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
    border-radius: 14px;
    text-align: center;
    line-height: 28px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .invoice_content {
    position: relative;
    padding-bottom: 88px;
    padding-top: 48px;
    .invoice_content_listBox {
      background: #f5f7fa;
    }
    .invoice_content_fix {
      position: fixed;
      bottom: 0;
      .invoice_content_fix_top {
        width: 375px;
        height: 34px;
        background: #e9feff;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2e4344;
        line-height: 34px;
        text-align: center;
      }
      .invoice_content_fix_bot {
        width: 375px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #f5f7fa;
        padding: 0 20px;
        .invoice_content_fix_bot_left {
          display: flex;
          align-items: center;
          span {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #2e4344;
            margin-left: 10px;
          }
        }
        .invoice_content_fix_bot_rig {
          width: 202px;
          height: 40px;
          background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
          border-radius: 20px;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
        }
      }
    }
  }

  .invoice_content_list {
    width: 335px;
    background: #ffffff;
    border-radius: 8px;
    margin-left: 20px;
    padding: 10px 20px;
    margin-top: 8px;
    .invoice_content_list_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #949c9d;
      }
    }
    .invoice_content_list_cen {
      display: flex;
      justify-content: space-between;
      .invoice_content_list_cen_img {
        width: 128px;
        height: 72px;
        border-radius: 4px;
      }
      .invoice_content_list_cen_right {
        width: 154px;
        margin-bottom: 8px;
        .invoice_content_list_cen_right_title {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2e4344;
          margin-bottom: 10px;
        }
        .invoice_content_list_cen_right_price {
          font-size: 20px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #fa7d00;
          float: right;
          span {
            font-size: 14px;
          }
        }
      }
    }
    .invoice_content_list_num {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #949c9d;
      margin-top: 4px;
    }
  }
  .noData {
    text-align: center;
    margin: 0 auto;
    margin-top: 84px;
    img {
      width: 140px;
    }
    p {
      margin-top: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #aaaaaa;
    }
  }
}
</style>
